package ui.hardware

import androidx.compose.runtime.*
import androidx.compose.ui.text.style.*
import androidx.compose.ui.unit.*
import api.*
import common.frontend.api.*
import compose.assets.*
import compose.assets.svg.*
import provider.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tools.*
import ui.*
import ui.widget.*


interface HardwareListingScope {

    val vmGlobal: GlobalVM
    val vm: HardwareListingVM
    val action: (HardwareListingVM.Action) -> Unit
    val nav: Navigation
    val login: Io.User
    val headers: ListingSpecs<Wrapper.Item>
    val canAdd: Boolean

    companion object {

        private val primaryHeaders = listOf<ListingSpecs.Item<Wrapper.Item>>(
            ListingSpecs.Item(title = Res.string.hardware_listing__item_id, width = 50.dp, align = TextAlign.Center, lines = 1) { ListingSpecs.trimmedId(it.data.id) },
            ListingSpecs.Item(title = Res.string.hardware_listing__item_name, width = 200.dp) { it.data.name },
            ListingSpecs.Item(title = Res.string.hardware_listing__item_can_apps, align = TextAlign.Center, width = 60.dp) {
                ListingItemBody.Icon(
                    if (HardwareCapability.APPS match it.data.capability) Svg.Check
                    else Svg.Close
                )
            },
            ListingSpecs.Item(title = Res.string.hardware_listing__item_can_fhd, align = TextAlign.Center, width = 60.dp) {
                ListingItemBody.Icon(
                    if (HardwareCapability.VIDEO_FHD match it.data.capability) Svg.Check
                    else Svg.Close
                )
            },
            ListingSpecs.Item(title = Res.string.hardware_listing__item_can_uhd, align = TextAlign.Center, width = 60.dp) {
                ListingItemBody.Icon(
                    if (HardwareCapability.VIDEO_UHD match it.data.capability) Svg.Check
                    else Svg.Close
                )
            },
        )

        @Composable
        fun rememberScope(): HardwareListingScope {
            val account = LocalAccountProvider.current
            val nav = LocalNavigation.current
            val vm = nav.viewModel(HardwareListingVM::class)
            val vmGlobal = globalViewModel(GlobalVM::class)
            val action = HardwareListingVM.Action.rememberAction(vm)


            return remember {

                val headers = ListingSpecs.create(
                    *primaryHeaders.toTypedArray()
                )
                object : HardwareListingScope {
                    override val vmGlobal: GlobalVM
                        get() = vmGlobal
                    override val vm: HardwareListingVM
                        get() = vm
                    override val action: (HardwareListingVM.Action) -> Unit
                        get() = action
                    override val nav: Navigation
                        get() = nav
                    override val login: Io.User
                        get() = account.current!!
                    override val headers: ListingSpecs<Wrapper.Item>
                        get() = headers
                    override val canAdd: Boolean
                        get() = login.canHardwareAdd()

                }.also {
                    vm.init(it)
                }
            }
        }
    }

    class Wrapper(
        hardware: Io.ListingHardware,
        val canAdd: Boolean
    ) : EFieldList<Io.ListingHardware.Hardware, Wrapper.Item>(
        items = hardware.items,
        onBindEntry = {
            Item(it)
        }
    ) {
        class Item(
            override val data: Io.ListingHardware.Hardware,
            override val key: String = data.id.toString(),
        ) : Entry<Io.ListingHardware.Hardware>
    }
}
